import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pageNo: 1,
  pageSize: 25
};

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    gotonextPage: (state) => {
      state.pageNo += 1;
    },
    gotopervousPage: (state) => {
      state.pageNo -= 1;
    },
    updatepage: (state, action) => {
      state.pageNo = action.payload;
    },
    updateSize: (state, action) => {
      state.pageSize = action.payload;
    },
    resetPage: () => initialState
  }
});

export default pageSlice.reducer;
export const { gotonextPage, gotopervousPage,
    updatepage, updateSize, resetPage } = pageSlice.actions;
